import Typography from '@mui/material/Typography';
import CachedIcon from '@mui/icons-material/Cached';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';

import {
  CodingStrategyEnum,
  getFragmentData,
  graphql,
} from '@e-socna/data-layer';
import type { CodingConfigManual, FragmentType } from '@e-socna/data-layer';

import { useReferencesContext } from '../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { colorToMuiColor } from '../utils/color-to-mui-color.util';
import { iconToMuiIcon } from '../utils/icon-to-mui-icon.util';

import { WordBreak } from './WordBreak';

export const CodeCmp_CodingConfig_Fragment = graphql(`
  fragment CodeCmp_CodingConfig_Fragment on CodingConfig {
    kind
    ... on CodingConfigManual {
      code
    }
  }
`);

interface Props {
  readonly codingConfig?: FragmentType<typeof CodeCmp_CodingConfig_Fragment>;
  readonly code?: string | null;
  readonly isDirty?: boolean;
}

export const Code = ({
  codingConfig: pCodingConfig,
  code,
  isDirty = false,
}: Readonly<Props>) => {
  const codingConfig = pCodingConfig
    ? getFragmentData(CodeCmp_CodingConfig_Fragment, pCodingConfig)
    : undefined;

  const { codingStrategiesCodeMap } = useReferencesContext();
  const codingStrategy = codingConfig
    ? codingStrategiesCodeMap[codingConfig.kind]
    : undefined;

  let text = 'Code : Non défini';
  let showMustSave = false;

  if (codingConfig?.kind === CodingStrategyEnum.CodingConfigManual) {
    const typedConfig = codingConfig as CodingConfigManual;

    if (typedConfig.code) {
      text = `Code : ${typedConfig.code}`;
    } else if (code) {
      text = `Code : ${code}`;
    }
  } else if (!codingConfig && code) {
    text = `Code : ${code}`;
    if (isDirty) {
      showMustSave = true;
    }
  } else {
    // TODO : In case of auto generated code
    if (code) {
      text = `Code : ${code}`;
    }
    if (isDirty) {
      showMustSave = true;
    }
  }

  return (
    <Typography component="div" gutterBottom variant="body1">
      <WordBreak>{text}</WordBreak>
      {!!codingStrategy?.chip && (
        <Chip
          color={colorToMuiColor(codingStrategy.chip.color)}
          icon={iconToMuiIcon(codingStrategy.chip.icon)}
          label={codingStrategy.label}
          size="small"
          sx={{ ml: 1, userSelect: 'none', verticalAlign: 'bottom' }}
          variant="outlined"
        />
      )}
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!showMustSave && (
        <Tooltip title="Sera regénéré, et peut-être modifié">
          <CachedIcon sx={{ ml: 1 }} />
        </Tooltip>
      )}
    </Typography>
  );
};
